import { SelectionRequest } from '@tiendanube/common';

export interface StepHistoryEntry {
  stepIndex: number;
  category: string[];
}

export interface FormState {
  currentStep: number;
  answers: Record<string, SelectionRequest[]>;
  currentStepCategory: string[];
  stepHistory: StepHistoryEntry[];
}

export type AnswerAction =
  | {
      type: 'ANSWER_GROUP';
      payload: {
        groupKey: string;
        values: SelectionRequest[];
      };
    }
  | {
      type: 'PREV_STEP';
    }
  | {
      type: 'SET_STEP_WITH_HISTORY';
      payload: {
        stepIndex: number;
        groupCategory: string[];
      };
    };

const formReducer = (state: FormState, action: AnswerAction): FormState => {
  switch (action.type) {
    case 'ANSWER_GROUP':
      return {
        ...state,
        answers: {
          ...state.answers,
          [action.payload.groupKey]: action.payload.values,
        },
      };
    case 'PREV_STEP': {
      if (state.stepHistory.length < 2) return state;

      const newHistory = [...state.stepHistory];
      newHistory.pop(); // Remove current step

      const prevEntry = newHistory.at(-1);

      if (!prevEntry) return state;

      return {
        ...state,
        currentStep: prevEntry.stepIndex,
        currentStepCategory: prevEntry.category,
        stepHistory: newHistory,
      };
    }
    case 'SET_STEP_WITH_HISTORY':
      return {
        ...state,
        currentStep: action.payload.stepIndex,
        currentStepCategory: action.payload.groupCategory,
        stepHistory: [
          ...state.stepHistory,
          {
            stepIndex: action.payload.stepIndex,
            category: action.payload.groupCategory,
          },
        ],
      };
    default:
      return state;
  }
};

export default formReducer;
